export default __webpack_public_path__ + "1d91db64f1bd7141c87001ebbcdc5b25.png";